import { isMatch, Link, useMatches } from "@tanstack/react-router";
import { Group, Text } from "@mantine/core";
import { Fragment } from "react/jsx-runtime";

export const Breadcrumb = () => {
  const matches = useMatches();
  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, "loaderData.crumb")
  );

  const items = matchesWithCrumbs.map(({ pathname, loaderData }) => {
    return {
      href: pathname,
      label: loaderData?.crumb
    };
  });

  return (
    <Group>
      {items.map((item, index) => (
        <Fragment key={item.href}>
          <Text size="xs" c={"blue"}>
            <Link to={item.href} className="breadcrumb-link">
              {item.label}
            </Link>
          </Text>
          {index < items.length - 1 && <Text size="xs">&gt;</Text>}
        </Fragment>
      ))}
    </Group>
  );
};
export default Breadcrumb;
